$(document).ready(function(){

    $('ul.energy-type-switch li').on('click', function (e) {
        var tab_id = $(this).attr('data-tab');

        var myhash =  '#' + tab_id.substring(4);
        if(history.pushState) {
            history.pushState(null, null, myhash );
        }
        else {
            location.hash = myhash;
        }

        e.preventDefault();

        $('ul.energy-type-switch li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    });

    if ( window.location.hash ) {
        var currentHash = window.location.hash;
        $('.tab-content').removeClass('current');
        $('ul.energy-type-switch li').removeClass('current');

        var tab = currentHash.substring(1);
        $('ul.energy-type-switch li[data-tab="tab-'+tab+'"]').addClass('current');
        $('#tab-' + tab).addClass('current');
    }

});